module.exports = __webpack_public_path__ + "img/mitutoyo.57310a3e.svg";